// IELTS Mock 6 — Listening (IELTS Fever Listening Practice Test 12)
// Same shape as IELTS_DATA_LISTENING in ../IeltsListening.js (4 parts, 40 questions,
// one audio track that plays once straight through).
// Groups with `chooseTwo` share one option list across two question numbers.
// Groups with `flow` render as a flow-chart: steps with a `qid` hold that question,
// steps with only `text` are fixed boxes.
// No `audioStart` timings yet, so the page doesn't auto-scroll between Parts.

const AUDIO_SRC = "/audio/ielts_listening6.mp3";

const IELTS_MOCK6_LISTENING = {
  title: "IELTS Listening Mock 6",
  sections: [
    {
      id: "s1",
      title: "Section 1: Tauber Insurance Co.",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 1–5: Complete the form below. Write ONE WORD AND/OR A NUMBER for each answer.",
          heading: "Tauber Insurance Co.",
          example: { q: "Insurance type: Vehicle" },
          image: null,
          questions: [
            { id: "q1", text: "Policy #: ______", type: "fill_blank", answer: ["ZQW5009"] },
            { id: "q2", text: "Make & Model: Masda Marvel — Engine size: ______", type: "fill_blank", answer: ["2500cc", "2500 cc", "2500"] },
            {
              id: "q3",
              text: "Name: Lisa Marie Heathcote — Date of Birth: ______ 1955",
              type: "fill_blank",
              answer: ["22nd August", "August 22nd", "22 August", "August 22", "22nd of August"],
            },
            { id: "q4", text: "Password: ______", type: "fill_blank", answer: ["jack 1897", "jack1897"] },
            { id: "q5", text: "Change valuation? Yes — Reduce value to: $ ______", type: "fill_blank", answer: ["15000", "$15000", "15,000"] },
          ],
        },
        {
          instruction:
            "Questions 6–10: Complete the notes below. Write ONE WORD ONLY for each answer.",
          heading: "Notes to be added to policy",
          image: null,
          questions: [
            { id: "q6", text: "Add new driver — Name: Samuel Michaels; Age: 28. Relationship to main driver: ______", type: "fill_blank", answer: ["son-in-law", "son in law", "soninlaw"] },
            { id: "q7", text: "Reason: ______", type: "fill_blank", answer: ["family"] },
            { id: "q8", text: "Client/new driver to provide: Verified ______ of driver's licence", type: "fill_blank", answer: ["copy", "photocopy", "photo copy"] },
            { id: "q9", text: "Client/new driver to provide: Clean driving ______", type: "fill_blank", answer: ["record"] },
            { id: "q10", text: "Start date: ______ cover for 2 weeks from today", type: "fill_blank", answer: ["temporary"] },
          ],
        },
      ],
    },

    {
      id: "s2",
      title: "Section 2: Confidence and Goal Setting",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 11–16: Complete the sentences below. Write NO MORE THAN TWO WORDS for each answer.",
          image: null,
          questions: [
            { id: "q11", text: "You can become more confident by using ______", type: "fill_blank", answer: ["positive thinking", "positive thoughts", "positive thought"] },
            { id: "q12", text: "More confidence results in better ______", type: "fill_blank", answer: ["performance"] },
            { id: "q13", text: "A good strategy to build confidence is to get rid of negative memories of mistakes and failures and, instead, concentrate on ______", type: "fill_blank", answer: ["successful outcomes", "successful outcome"] },
            { id: "q14", text: "Frequent ______ of positive imagery is necessary for success.", type: "fill_blank", answer: ["rehearsal", "rehearsals"] },
            { id: "q15", text: "Mental positivity is not enough — you also have to act in a confident manner — so ______ is important too.", type: "fill_blank", answer: ["body language"] },
            { id: "q16", text: "Setting and achieving goals results in brain activity that brings about an experience of ______", type: "fill_blank", answer: ["happiness"] },
          ],
        },
        {
          instruction:
            "Questions 17–20: Complete the flow chart below. Write NO MORE THAN TWO WORDS for each answer.",
          heading: "Goal Setting",
          image: null,
          flow: [
            { qid: "q17" },
            { text: "Decide on incentives." },
            { qid: "q18" },
            { qid: "q19" },
            { text: "Take the first step." },
            { qid: "q20" },
          ],
          questions: [
            { id: "q17", text: "Set an ______ goal.", type: "fill_blank", answer: ["appropriate", "achievable"] },
            { id: "q18", text: "______ steps along the way.", type: "fill_blank", answer: ["work out", "prepare", "prepare for", "work out for"] },
            { id: "q19", text: "Gather ______", type: "fill_blank", answer: ["resources"] },
            { id: "q20", text: "Keep a ______", type: "fill_blank", answer: ["progress log"] },
          ],
        },
      ],
    },

    {
      id: "s3",
      title: "Section 3: Discussion on a Science Project",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 21–23: Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q21",
              text: "Julia and Bob's science project is due",
              type: "mcq",
              options: ["A. next week.", "B. next month.", "C. next year."],
              answer: "A",
            },
            {
              id: "q22",
              text: "All the materials they use must be",
              type: "mcq",
              options: ["A. recycled.", "B. inexpensive.", "C. available in the lab."],
              answer: "B",
            },
            {
              id: "q23",
              text: "A Cartesian diver was called a 'devil' by some people because",
              type: "mcq",
              options: [
                "A. they saw it was black.",
                "B. they believed in the supernatural.",
                "C. they wanted the inventor to be famous.",
              ],
              answer: "B",
            },
          ],
        },
        {
          instruction: "Questions 24–25: Choose TWO letters, A–E.",
          chooseTwo: true,
          question: "Julia and Bob find some of the items they need",
          options: [
            "A. in Bob's pencil case and the recycling bin.",
            "B. in the cafeteria and the Resource Centre.",
            "C. in the shop and Julia's locker.",
            "D. in Bob's bag and his pocket.",
            "E. in Tara's packet and on the floor.",
          ],
          answer: ["C", "E"],
          questions: [{ id: "q24" }, { id: "q25" }],
        },
        {
          instruction:
            "Questions 26–30: Complete the notes below. Write NO MORE THAN TWO WORDS for each answer.",
          heading: "Assembly",
          image: null,
          questions: [
            { id: "q26", text: "Step 1 — Fold ______ in half.", type: "fill_blank", answer: ["straw", "the straw"] },
            { id: "q27", text: "Step 2 — Use ______ to secure the ends.", type: "fill_blank", answer: ["rubber band", "rubber bands"] },
            { id: "q28", text: "Step 3 — Attach ______ to diver.", type: "fill_blank", answer: ["paper clips", "paper clip"] },
            { id: "q29", text: "Step 4 — Fill bottle with water and replace ______", type: "fill_blank", answer: ["cap", "lid", "cap/lid"] },
            { id: "q30", text: "Step 5 — Demonstrate by squeezing and releasing bottle. Compression causes diver to sink because diver becomes ______", type: "fill_blank", answer: ["heavier"] },
          ],
        },
      ],
    },

    {
      id: "s4",
      title: "Section 4: Lecture on Volcano Activity",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 31–35: Answer the questions below. Write NO MORE THAN THREE WORDS AND/OR A NUMBER for each answer.",
          image: null,
          questions: [
            { id: "q31", text: "When did Mt. Pinatubo erupt for the first time? ______", type: "fill_blank", answer: ["5,500 years ago", "5500 years ago", "5,500 years", "5500 years"] },
            { id: "q32", text: "When was the earthquake measuring 7.8 recorded? ______", type: "fill_blank", answer: ["July 1990"] },
            { id: "q33", text: "When did the experts begin to study Mt. Pinatubo? ______", type: "fill_blank", answer: ["mid-March 1991", "mid March 1991", "midmarch 1991"] },
            { id: "q34", text: "What fell on the local villages on 2nd April? ______", type: "fill_blank", answer: ["ash"] },
            { id: "q35", text: "What does a 'Level 5' alert mean? ______", type: "fill_blank", answer: ["eruption in progress"] },
          ],
        },
        {
          instruction:
            "Questions 36–40: Complete the summary below. Write NO MORE THAN THREE WORDS for each answer.",
          heading: "The eruption of Pinatubo (15th June 1991)",
          image: null,
          questions: [
            { id: "q36", text: "Several large earthquakes were triggered by the eruption of Pinatubo on 15th June 1991 because of the ______ of the summit. The 'caldera' thus created considerably reduced the height of the mountain.", type: "fill_blank", answer: ["collapse"] },
            { id: "q37", text: "At the same time a ______ was passing by and the rain associated with it mixed with the cinders in the air to form a substance called 'tephra' ...", type: "fill_blank", answer: ["tropical storm"] },
            { id: "q38", text: "... which fell on the ______ of homes causing them to collapse, crushing hundreds of people.", type: "fill_blank", answer: ["roofs"] },
            { id: "q39", text: "During the eruption, large amounts of sulphur dioxide gas were emitted, which combined with ______ to make sulphuric acid which was responsible for a great deal of ozone depletion above Antarctica.", type: "fill_blank", answer: ["water and oxygen", "oxygen and water"] },
            { id: "q40", text: "The overall effect of the cloud from this great eruption was the lowering of ______", type: "fill_blank", answer: ["global temperatures", "global temperature"] },
          ],
        },
      ],
    },
  ],
};

export default IELTS_MOCK6_LISTENING;
